<template>
  <div class="call-parent">
    <div class="logo">
      <!-- Início imagem da logo -->
      <img
        src="https://feedback-dominos.s3.amazonaws.com/img/email/logo.png"
        alt="Logotipo Domino's"
      />
      <!-- Fim da imagem da logo -->
    </div>
    <div class="call-top">
      <!-- Início imagem do topo-->
      <router-link
        title="Participe de nossa pesquisa e nos ajude a continuar sendo a maior pizzaria do mundo!"
        style="outline: 0;border:0;"
        to="/pesquisa-publica"
      >
        <img
          src="https://feedback-dominos.s3.amazonaws.com/img/email/imagem01.jpg"
          alt="Pesquisa de satisfação"
        />
      </router-link>
      <!-- Fim da imagem do topo-->
    </div>
    <div class="call-main">
      <!-- Início imagem do meio-->

      <router-link
        to="/pesquisa-publica"
        title="Participe de nossa pesquisa e nos ajude a continuar sendo a maior pizzaria do mundo!"
        style="outline: 0;border:0;"
      >
        <img
          src="https://feedback-dominos.s3.amazonaws.com/img/email/imagem02.jpg"
          alt="Participar"
        />
      </router-link>
      <!-- Fim imagem do meio-->
    </div>
    <div class="call-action">
      <router-link
        to="/pesquisa-publica"
        title="Participe de nossa pesquisa e nos ajude a continuar sendo a maior pizzaria do mundo!"
        style="outline: 0;border:0;"
      >
        <img
          src="https://feedback-dominos.s3.amazonaws.com/img/email/imagem03.jpg"
          alt="Participar"
        />
      </router-link>
      <!-- Fim imagem do rodapé-->
    </div>
  </div>
  <!--call-parent-->
</template>

<script>

export default {
  name: 'callPage'
}

</script>

<style scoped>
.call-parent {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 40px 15px;
  height: 100%;
  width: 100%;
  background-color: #006491;
}

.call-parent > div {
  max-width: 600px;
  text-align: center;
  margin: 10px 0;
}

.call-parent > div > a,
.call-parent > div > a > img {
  width: 100%;
}

div.logo {
  margin-bottom: 40px;
}

@media screen and (max-width: 680px) {
  .call-parent > div {
    max-width: 500px;
  }
}

@media screen and (max-width: 560px) {
  .call-parent > div {
    max-width: 450px;
  }
}

@media screen and (max-width: 480px) {
  .call-parent > div {
    max-width: 400px;
  }

  div.logo {
    max-width: 350px;
  }

  div.logo img {
    max-width: 100%;
  }
}

@media screen and (max-width: 460px) {
  .call-parent > div {
    max-width: 350px;
  }
}

@media screen and (max-width: 420px) {
  .call-parent > div {
    max-width: 350px;
  }
  div.logo {
    max-width: 250px;
  }
}
</style>
